export default {
  type: 'Container',
  components: [
    {
      type: 'Component',
      skin: 'skins.viewer.VectorImageSkin',
      layout: {
        width: 30,
        height: 32,
        x: 35,
        y: 34,
        scale: 1,
        rotationInDegrees: 0,
        fixedPosition: false,
      },
      componentType: 'wysiwyg.viewer.components.VectorImage',
      metaData: {
        pageId: 'h0eq4',
      },
      parent: 'comp-kgt65vsw',
      data: {
        type: 'VectorImage',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'h0eq4',
        },
        svgId: '11062b_9540a32f7c7445e5ac7f4a6471d63899.svg',
      },
      props: {
        type: 'VectorImageProperties',
        metaData: {
          schemaVersion: '1.0',
          autoGenerated: false,
          pageId: 'h0eq4',
        },
        displayMode: 'stretch',
        flip: 'none',
      },
      design: {
        type: 'VectorImageDesignData',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'h0eq4',
        },
        overrideColors: {
          color1: '#5C996E',
        },
        shapeStyle: {
          opacity: 1,
          strokeWidth: 1,
          stroke: '#F97F5F',
          strokeOpacity: 1,
          enableStroke: false,
        },
      },
      style: {
        type: 'ComponentStyle',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'h0eq4',
        },
        style: {
          properties: {},
          propertiesSource: {},
          groups: {},
        },
        componentClassName: 'wysiwyg.viewer.components.VectorImage',
        styleType: 'custom',
        skin: 'skins.viewer.VectorImageSkin',
      },
      mobileStructure: {
        layout: {
          width: 30,
          height: 32,
          x: 35,
          y: 34,
          scale: 1,
          rotationInDegrees: 0,
          fixedPosition: false,
        },
        metaData: {
          originalCompId: 'comp-kgt65vtw2',
          author: 'studio',
        },
      },
    },
  ],
  skin: 'wysiwyg.viewer.skins.area.CircleArea',
  layout: {
    width: 100,
    height: 100,
    x: 440,
    y: 161,
    scale: 1,
    rotationInDegrees: 0,
    fixedPosition: false,
  },
  componentType: 'mobile.core.components.Container',
  metaData: {
    pageId: 'h0eq4',
  },
  parent: 'h0eq4',
  variants: {
    'variants-kgt65vtv': {
      componentId: 'comp-kgt65vsw',
      type: 'Hover',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'h0eq4',
      },
    },
  },
  transitions: {
    type: 'TransitionData',
    'timing-function': 'ease-in-out',
    duration: 0.4,
    delay: 0,
    metaData: {
      isPreset: false,
      schemaVersion: '1.0',
      isHidden: false,
      pageId: 'h0eq4',
    },
  },
  scopedTransformations: {
    'variants-kgt65vtv': {
      type: 'TransformData',
      zLayer: 'BELOW_PINNED',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'h0eq4',
      },
    },
  },
  scopedStyles: {
    'variants-kgt65vtv': {
      type: 'ComponentStyle',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'h0eq4',
      },
      style: {
        properties: {
          'alpha-bg': '1',
          'alpha-brd': '1',
          bg: 'rgba(201,225,208,1)',
          'boxShadowToggleOn-shd': 'false',
          brd: '#72B084',
          brw: '0',
          shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
        },
        propertiesSource: {
          'alpha-bg': 'value',
          'alpha-brd': 'value',
          bg: 'value',
          'boxShadowToggleOn-shd': 'value',
          brd: 'value',
          brw: 'value',
          shd: 'value',
        },
        groups: {},
      },
      componentClassName: 'mobile.core.components.Container',
      pageId: '',
      compId: '',
      styleType: 'custom',
      skin: 'wysiwyg.viewer.skins.area.CircleArea',
    },
  },
  style: {
    type: 'ComponentStyle',
    metaData: {
      isPreset: false,
      schemaVersion: '1.0',
      isHidden: false,
      pageId: 'h0eq4',
    },
    style: {
      properties: {
        'alpha-bg': '1',
        'alpha-brd': '1',
        bg: 'rgba(255,255,255,1)',
        'boxShadowToggleOn-shd': 'false',
        brd: '#72B084',
        brw: '3',
        shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
      },
      propertiesSource: {
        'alpha-bg': 'value',
        'alpha-brd': 'value',
        bg: 'value',
        'boxShadowToggleOn-shd': 'value',
        brd: 'value',
        brw: 'value',
        shd: 'value',
      },
      groups: {},
    },
    componentClassName: 'mobile.core.components.Container',
    pageId: '',
    compId: '',
    styleType: 'custom',
    skin: 'wysiwyg.viewer.skins.area.CircleArea',
  },
  mobileStructure: {
    layout: {
      width: 100,
      height: 100,
      x: 110,
      y: 10,
      scale: 1,
      rotationInDegrees: 0,
      fixedPosition: false,
    },
    metaData: {
      originalCompId: 'comp-kgt65vsw',
      author: 'studio',
    },
  },
  activeModes: {},
};
